import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-builder-renderer" }
const _hoisted_2 = {
  key: 0,
  class: "el-custom-select"
}
const _hoisted_3 = {
  key: 1,
  class: "wpcm-pre-dfind-amt"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "wpcm-custm-amt-box"
}
const _hoisted_6 = {
  key: 0,
  class: "wpcm-field-label",
  style: {"display":"block","margin-bottom":"8px","font-weight":"500"}
}
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = {
  key: 0,
  class: "wpcm-symbl-prefix"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 3,
  class: "wpcm-recurring-btns",
  style: {"margin":"15px 0"}
}
const _hoisted_11 = {
  key: 0,
  class: "wpcm-field-label",
  style: {"display":"block","margin-bottom":"8px","font-weight":"500"}
}
const _hoisted_12 = {
  class: "d-inline-flex",
  style: {"list-style":"none","padding":"0","margin":"0","gap":"10px"}
}
const _hoisted_13 = {
  key: 4,
  class: "el-custom-select"
}
const _hoisted_14 = {
  key: 5,
  class: "el-custom-select"
}
const _hoisted_15 = {
  key: 0,
  class: "wpcm-payment-gateways"
}
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "wpcm-gateway-list"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "wpcm-gateway-testing-info mb-3"
}
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Step 1 Fields "),
    ($props.step === 'step_1')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.step1Fields, (field) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: field.id
          }, [
            _createCommentVNode(" Currency Selector "),
            (field.type === 'currency_selector')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: $setup.store.currency,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.currency) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.store.currency = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.currencies, (curr, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          value: key,
                          key: key,
                          label: curr
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Predefined Amounts "),
            (field.type === 'predefined_amounts' && !$setup.store.recurring)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAmounts(field), (amount, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(parseFloat(amount))), ["prevent"])
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass(['wpdonation-button', $setup.store.amount == $setup.convert(parseFloat(amount)) && 'active'])
                      }, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.convert(parseFloat(amount))), 3 /* TEXT, CLASS */)
                    ], 8 /* PROPS */, _hoisted_4))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Custom Amount Input "),
            (field.type === 'custom_amount')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (field.label)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(field.label), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_7, [
                    ($props.symbol)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.getSymbol()), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.amount) = $event)),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateAmount($event))),
                      onKeypress: $setup.isNumber,
                      placeholder: field.placeholder || field.label || 'Enter amount',
                      style: {"flex":"1"}
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9), [
                      [
                        _vModelText,
                        $setup.store.amount,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Recurring Toggle "),
            (field.type === 'recurring_toggle')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (field.label)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_11, _toDisplayString(field.label), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("ul", _hoisted_12, [
                    _createElementVNode("li", {
                      class: "m-0",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.setRecurring(false)), ["prevent"])),
                      style: {"margin":"0"}
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass(['wpdonation-button', !$setup.store.recurring && 'active']),
                        style: {"text-decoration":"none","padding":"10px 20px","display":"inline-block","border":"1px solid #ddd","border-radius":"4px","cursor":"pointer"}
                      }, _toDisplayString(field.one_time_label || $props.strings?.one_time || 'One Time'), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("li", {
                      class: "m-0",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.setRecurring(true)), ["prevent"])),
                      style: {"margin":"0"}
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass(['wpdonation-button', $setup.store.recurring && 'active']),
                        style: {"text-decoration":"none","padding":"10px 20px","display":"inline-block","border":"1px solid #ddd","border-radius":"4px","cursor":"pointer"}
                      }, _toDisplayString(field.recurring_label || $props.strings?.recurring || 'Recurring'), 3 /* TEXT, CLASS */)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Causes Dropdown "),
            (field.type === 'causes_dropdown')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: $setup.store.selectedCause,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.store.selectedCause) = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.setValue('selectedCause', $event))),
                    placeholder: field.required ? 'Select Any Cause *' : 'Select Any Cause',
                    required: field.required
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.causes_list, (cause, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          value: key,
                          label: cause
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cause), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "placeholder", "required"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Honoree Dropdown "),
            (field.type === 'honoree_dropdown')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: $setup.store.extras.donation_custom_dropdown,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.store.extras.donation_custom_dropdown) = $event)),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.setValue('donation_custom_dropdown', $event))),
                    placeholder: field.placeholder || 'Select Any Honoree',
                    required: field.required
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.donation_custom_dropdown, (honoree, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          value: key,
                          key: key,
                          label: honoree
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(honoree), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "placeholder", "required"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Step 2 Fields (Billing) "),
    ($props.step === 'step_2')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($setup.step2Fields.length > 0)
            ? (_openBlock(), _createBlock($setup["FormBuilderFields"], {
                key: 0,
                "billing-form-data": $props.billingFormData,
                "form-fields": $setup.step2Fields
              }, null, 8 /* PROPS */, ["billing-form-data", "form-fields"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Step 3 Fields (Payment) "),
    ($props.step === 'step_3')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.step3Fields, (field) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: field.id
          }, [
            _createCommentVNode(" Payment Gateways "),
            (field.type === 'payment_gateways')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    ($props.gateways)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.gateways, (gateway, gateway_id) => {
                            return (_openBlock(), _createElementBlock("li", { key: gateway_id }, [
                              _createElementVNode("a", {
                                onClick: _withModifiers(($event: any) => ($setup.store.payment_method = gateway.id), ["prevent"]),
                                class: _normalizeClass([(gateway.id === $setup.store.payment_method) && 'active']),
                                title: "",
                                href: "#"
                              }, [
                                (gateway.icon)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      _createElementVNode("img", {
                                        src: gateway.icon,
                                        alt: ""
                                      }, null, 8 /* PROPS */, _hoisted_20)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createTextVNode(" " + _toDisplayString(gateway.title ? gateway.title : gateway.name), 1 /* TEXT */)
                              ], 10 /* CLASS, PROPS */, _hoisted_18)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.selectedTestingInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", {
                          class: "wpcm-gateway-testing-info__text",
                          innerHTML: $setup.selectedTestingInfo
                        }, null, 8 /* PROPS */, _hoisted_22)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}